<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <el-menu-item index="1" @click="toNewRouter('video-alarm-over-view')" v-if="permissionCodes.indexOf('043001000') !== -1">
        <i class="el-icon-damai-shujulaiyuan"></i>
        <span slot="title">概览</span>
      </el-menu-item>
      <el-menu-item index="2" @click="toNewRouter('police-point-management')" v-if="permissionCodes.indexOf('043002000') !== -1">
        <i class="el-icon-damai-ic_jiancedianguanli"></i>
        <span slot="title">报警点管理</span>
      </el-menu-item>
      <el-menu-item index="5" @click="toNewRouter('video-alarm-record')" v-if="permissionCodes.indexOf('043003000') !== -1">
        <i class="el-icon-damai-ic_keliutongji"></i>
        <span slot="title">报警记录</span>
      </el-menu-item>
      <el-menu-item index="3" @click="toNewRouter('video-alarm-statistics')" v-if="permissionCodes.indexOf('043003000') !== -1">
        <i class="el-icon-damai-ic_keliutongji"></i>
        <span slot="title">报警统计</span>
      </el-menu-item>
      <el-menu-item index="4" @click="toNewRouter('video-log')" v-if="permissionCodes.indexOf('043004000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
     </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  1: "video-alarm-over-view",
  2: [
    "police-point-management",
    "police-point-management-add",
    "police-point-management-modify"
  ],
  3: "video-alarm-statistics",
  5: "video-alarm-record",
  4: "video-log"
});

export default {
  name: "customer-flow-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    }
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      indexOfRouterNameEntities
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", data => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/VideoAlarm/VideoAlarmNav.vue